/**
 * @name users-round-collaboration
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjAuNDUzIDguOTExYTkgOSAwIDAwLTYuNjk2LTUuNzM4IiAvPgogIDxwYXRoIGQ9Ik0yMSAyMmE0IDQgMCAwMC04IDAiIC8+CiAgPHBhdGggZD0iTTMgMTJhNCA0IDAgMDE3Ljk2My0uNTQzIiAvPgogIDxwYXRoIGQ9Ik0zLjg4OSAxNS45YTkgOSAwIDAwNS4yNDcgNC42MzIiIC8+CiAgPGNpcmNsZSBjeD0iMTciIGN5PSIxNSIgcj0iMyIgLz4KICA8Y2lyY2xlIGN4PSI3IiBjeT0iNSIgcj0iMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/users-round-collaboration
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const UsersRoundCollaboration: string = `
<svg
  class="lucide lucide-users-round-collaboration"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M20.453 8.911a9 9 0 00-6.696-5.738" />
  <path d="M21 22a4 4 0 00-8 0" />
  <path d="M3 12a4 4 0 017.963-.543" />
  <path d="M3.889 15.9a9 9 0 005.247 4.632" />
  <circle cx="17" cy="15" r="3" />
  <circle cx="7" cy="5" r="3" />
</svg>
`;

export default UsersRoundCollaboration;
